import { AuthError, AuthenticationResult, InteractionType, RedirectRequest } from "@azure/msal-browser";

import { RenderingStatus } from "Enumerations";
import { Types } from "Shared/Utils";

const loginTypeKey = "loginType";

const isValidLoginType = (value: string): value is "Microsoft" | "Torus" | "Gallatin" => value === "Microsoft" || value === "Torus" || value === "Gallatin";

export const AuthStore = () => ({
    loginStatus: RenderingStatus.Waiting,
    readyToCheckRole: false,
    temporaryLogin: false,
    pcaInstanceVersion: 0,
    forceInteractiveLogin: false,
    login: (interactionType: InteractionType, request?: RedirectRequest): Promise<AuthenticationResult | null> => Promise.resolve(null),
    getToken: (): Promise<string | undefined> => Promise.resolve(undefined),
    error: Types.getUndefined<AuthError>(),
    IsTorusRequirementMet: Types.getUndefined<boolean>(),
    setLoginStatus(status: RenderingStatus, err?: AuthError) {
        this.error = err;
        this.loginStatus = status;
    },
    SetTorusRequirementMet(ismet: boolean) {
        this.IsTorusRequirementMet = ismet;
    },
    requestInteractiveLogin() {
        this.forceInteractiveLogin = true;
    },
    clearInteractiveLoginRequest() {
        this.forceInteractiveLogin = false;
    },
    // loginType is used to connect to the correct AAD endpoint. it's not for the after login. use myStore instead.
    loginType: Types.getUndefined<"Microsoft" | "Torus" | "Gallatin">(),
    get LoginType(): "Microsoft" | "Torus" | "Gallatin" {
        if (!this.loginType) {
            const storedLoginType = localStorage.getItem(loginTypeKey);
            this.loginType = storedLoginType && isValidLoginType(storedLoginType) ? storedLoginType : "Microsoft";
        }
        return this.loginType;
    },
    saveLoginType(value: "Microsoft" | "Torus" | "Gallatin") {
        this.loginType = value;
        this.pcaInstanceVersion += 1;
        localStorage.setItem(loginTypeKey, value);
    }
});

export type AuthStoreReturnType = ReturnType<typeof AuthStore>;
